// Tiny shimmer SVG used as blurDataURL placeholder for remote images.
// Matches the bg-slate-100 (#F1F5F9) background used in image containers.
const shimmerSvg = `
<svg width="400" height="300" xmlns="http://www.w3.org/2000/svg">
  <rect width="400" height="300" fill="#F1F5F9"/>
  <rect width="400" height="300" fill="url(#shimmer)"/>
  <defs>
    <linearGradient id="shimmer" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#F1F5F9"/>
      <stop offset="50%" stop-color="#E2E8F0"/>
      <stop offset="100%" stop-color="#F1F5F9"/>
    </linearGradient>
  </defs>
</svg>`

export const SHIMMER_BLUR_DATA_URL = `data:image/svg+xml;base64,${Buffer.from(shimmerSvg.trim()).toString("base64")}`

export const UF_OPTIONS = [
  "AC","AL","AM","AP","BA","CE","DF","ES","GO","MA",
  "MG","MS","MT","PA","PB","PE","PI","PR","RJ","RN",
  "RO","RR","RS","SC","SE","SP","TO",
] as const
